<template>
  <div v-if="count > 0" class="op-badge module-box-badge" :class="badgeColor">
    {{ count }}
  </div>
</template>

<script>
export default {
  name: 'ModuleBoxBadge',
  props: {
    count: Number,
    badgeColor: String,
  },
};
</script>

<style scoped>
.module-box-badge {
  position: absolute;
  top: -6px;
  right: -2px;
}
</style>
